import { Dialog } from '@headlessui/react';
import cn from 'classnames';

import styles from './SpendingLimitDrawer.module.css';
import { useGetSpendingLimits } from '../hooks/useGetSpendingLimits';
import { Icon } from '@iwoca/orion';
import { Application } from '../Dashboard.types';
import { ValidLimitDrawer } from './components/ValidLimitDrawer';
import { ExpiredLimitDrawer } from './components/ExpiredLimitDrawer';
import { DeclinedLimitDrawer } from './components/DeclinedLimitDrawer';
import { getSpendingLimitStatus } from '../Dashboard.helpers';

export const SpendingLimitDrawer = ({
    isOpen,
    setIsOpen,
    refreshSpendingLimit,
    loadingRefreshSpendingLimit,
    isError,
    application
}: {
    isOpen: boolean;
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
    refreshSpendingLimit: () => Promise<void>;
    loadingRefreshSpendingLimit: boolean;
    isError: boolean;
    application: Application | null;
}) => {
    const { spendingLimits, loadingSpendingLimits } = useGetSpendingLimits();

    if (!spendingLimits || loadingSpendingLimits) return null;

    const status = getSpendingLimitStatus({ spendingLimits, application });

    return (
        <>
            {isOpen && <div className={styles.filterDrawerBackdrop}></div>}
            <Dialog static open={isOpen} onClose={() => setIsOpen(false)}>
                <Dialog.Panel
                    className={cn(styles.outerContainer, {
                        [styles.outerContainerClosed]: !isOpen
                    })}
                >
                    <div className={styles.header}>
                        <Dialog.Title className={styles.headerTitle}>
                            {`Your spending limits${
                                status === 'declined' ? '' : '*'
                            }`}
                        </Dialog.Title>
                        <Icon
                            icon="timesDefault"
                            className={styles.closeButton}
                            width={24}
                            height={24}
                            onClick={() => {
                                setIsOpen(false);
                            }}
                        />
                    </div>
                    {status === 'valid' && (
                        <ValidLimitDrawer spendingLimits={spendingLimits} />
                    )}
                    {status === 'expired' && (
                        <ExpiredLimitDrawer
                            spendingLimits={spendingLimits}
                            refreshSpendingLimit={refreshSpendingLimit}
                            loadingRefreshSpendingLimit={
                                loadingRefreshSpendingLimit
                            }
                            isError={isError}
                        />
                    )}
                    {status === 'declined' && (
                        <DeclinedLimitDrawer
                            spendingLimits={spendingLimits}
                            refreshSpendingLimit={refreshSpendingLimit}
                            loadingRefreshSpendingLimit={
                                loadingRefreshSpendingLimit
                            }
                            isError={isError}
                            application={application!}
                        />
                    )}
                </Dialog.Panel>
            </Dialog>
        </>
    );
};
